import { depositBalance, getBalance, getBalanceActivities } from "../../api/site";
import { log2 } from "../../utils/log2";
import moment from "moment";

const log = log2("wallet.vuex");
const wallet = {
    namespaced: true,
    state: {
        wallet: {},
        activities: [],
        totalActivity: 0,
    },
    mutations: {
        SET_BALANCE: (state, payload) => {
            state.wallet = payload;
        },
        SET_BALANCE_ACTIVITY: (state, payload) => {
            state.activities = payload;
        },
        SET_TOTAL_ACTIVITY: (state, payload) => {
            state.totalActivity = payload;
        },
    },
    actions: {
        getBalance({ commit }) {
            getBalance().then((balance) => {
                const mapBalance = balance.reduce((acc, wallet) => {
                    acc[wallet.type] = wallet;
                    return acc;
                }, {});
                commit("SET_BALANCE", mapBalance);
            });
        },
        getWalletLogs({ commit }, { page = 1, perPage = 20, type = null, channelId = null, startDate, endDate, product = null, dateOperator = null, ref = null }) {
            if (startDate) startDate = moment(startDate).toString();
            if (endDate) endDate = moment(endDate).toString();
            getBalanceActivities(page, perPage, type, channelId, startDate, endDate, product, dateOperator, ref).then((data) => {
                commit("SET_BALANCE_ACTIVITY", data.activities);
                commit("SET_TOTAL_ACTIVITY", data.total);
            });
        },
        addBalance({ commit, state }, payload) {
            return depositBalance(payload).then((balance) => {
                commit("SET_BALANCE", {
                    ...state.wallet,
                    [balance.type]: balance,
                });
                return balance;
            });
        },
    },
};

export default wallet;
